import { createMainResourceREST } from '../resource';
import {
  ChargeableExistingActions,
  ChargeableExistingState,
  CRChargeableExistingBody,
  CRChargeableExistingBodyAPI,
  CRChargeableExistingKey,
  CRChargeableExistingSummary,
  CRChargeableExistingSummaryAPI,
} from './types';

type AnyChargeableExisting =
  | CRChargeableExistingKey
  | CRChargeableExistingSummary
  | CRChargeableExistingBody
  | undefined;

function sameKeyChargeableExisting(
  a: AnyChargeableExisting,
  b: AnyChargeableExisting,
): boolean {
  return a?.chargeableId === b?.chargeableId;
}

function getEndpointChargeableExisting(key: AnyChargeableExisting): string {
  return key?.chargeableId
    ? `/chargeables/existing/${key.chargeableId}`
    : '/chargeables/existing/';
}

function parseChargeableExistingSummary(
  chargeableExistingSummary: CRChargeableExistingSummaryAPI,
): CRChargeableExistingSummary {
  return chargeableExistingSummary;
}

function parseChargeableExistingBody(
  chargeableExistingBody: CRChargeableExistingBodyAPI,
): CRChargeableExistingBody {
  // TODO
  return chargeableExistingBody;
}

function mergeChargeableExistingBody(
  lastBody: CRChargeableExistingBody,
  currentBody: CRChargeableExistingBody,
) {
  return currentBody;
}

const chargeableExistingStateSelector = (state: any): ChargeableExistingState =>
  state.chargeableExisting;
const chargeableExistingKeySelector = ({
  chargeableId,
}:
  | CRChargeableExistingSummary
  | CRChargeableExistingBody): CRChargeableExistingKey => ({ chargeableId });

function combineSummaryBodyChargeableExisting(
  summary?: CRChargeableExistingSummary,
): CRChargeableExistingSummary {
  return summary!; // TODO not modifiable.
  // const merge = mergeSummaryBodyField(summary, detail);
  // return {
  //   supplierId: merge('supplierId'),
  //   supplierName: merge('supplierName'),
  //   scope: merge('scope'),
  //   isActive: merge('isActive'),
  //   isActiveForSite: merge('isActiveForSite'),
  //   childAccess: merge('childAccess'),
  //   isGlassSupplier: merge('isGlassSupplier'),
  //   rowKey: merge('rowKey'),
  // };
}

const { actions, reducer, watches } = createMainResourceREST(
  'chargeableExisting',
  getEndpointChargeableExisting,
  chargeableExistingStateSelector,
  sameKeyChargeableExisting,
  parseChargeableExistingBody,
  parseChargeableExistingSummary,
  mergeChargeableExistingBody,
  combineSummaryBodyChargeableExisting,
  // formatSupplierBody,
  // validateSuppliers,
);

const chargeableExistingActions: ChargeableExistingActions = actions;
export * from './types';
export {
  chargeableExistingActions,
  reducer as chargeableExistingReducer,
  watches as chargeableExistingWatches,
  chargeableExistingStateSelector,
  chargeableExistingKeySelector,
};
